const utils = require('../lib/utils')

const resources             = {} // store all etag resources within this object for later usage
const etags                 = {} // store all etags within this object for later usage
const requestPropertyList   = {} // stores all requestProperties by heartbeatKey and resourceHash

module.exports = {

    /**
     * returns a resource identified by etag if possible or false otherwise.
     *
     * @param etag          etag given by the server response header
     * @return {boolean|*}
     */
    getResource: function(etag){
        if(resources[etag]){
            return resources[etag]
        }

        return false
    },

    /**
     * sets a resource identified by etag within the resource storage.
     *
     * @param etag          etag given by the server response header
     * @param resource      mixed - anything you like to store locally ;-)
     */
    setResource: function(etag, resource){
        delete (resource || {}).updateClientStorage
        delete ((((resource || {}).children || {})[(resource || {}).childLayoutIndex || 0] || {}).model || {}).updateClientStorage
        resources[etag] = resource
    },

    /**
     * check if etag is present and has been issued by the fec-server and not anyone else.
     * returns the valid etag or false otherwise.
     *
     * @param etag          etag given by the server response header
     * @return {boolean|string}
     */
    returnETagIfValid: function(etag){
        if(String(etag || '').match(/^(W[/]"?)?fec_/) !== null){
            return etag
        }

        return false
    },

    /**
     * get an etag identified by the given parameters or false otherwise.
     *
     * @param resourceHash      string - hash to identify the etag
     * @return {boolean|string}
     */
    getETag: function(resourceHash){

        if(etags[resourceHash]){
            return etags[resourceHash]
        }

        return false
    },

    /**
     * stores a new etag for the given parameters.
     *
     * @param resourceHash      string - hash to identify the etag
     * @param etag              string - etag
     */
    setETag: function(resourceHash, etag){
        etags[resourceHash] = etag
    },

    /**
     * registers properties needed for prewarmer to request the new resources.
     *
     * @param heartbeatRefreshOn        object - list of heartbeatKeys (values have to be !!true) to associate the given requestProperties to.
     * @param resourceHash              string - resourceHash to identify the resource
     * @param requestProperties         object - properties to use for $.ajax
     */
    registerRequestProperties(heartbeatRefreshOn, resourceHash, requestProperties){
        heartbeatRefreshOn = heartbeatRefreshOn || {}
        if(!resourceHash || !requestProperties) return;

        for(const heartbeatKey in heartbeatRefreshOn){
            if(heartbeatRefreshOn[heartbeatKey]){
                requestPropertyList[heartbeatKey] = requestPropertyList[heartbeatKey] || {}
                requestPropertyList[heartbeatKey][resourceHash] = requestProperties
            }
        }
    },

    /**
     * prewarms all resources associated with the given heartbeatKey
     *
     * @param heartbeatKey      string - heartbeatKey to prewarm e.g., TODO: POI
     * @returns {Promise<{}>}   list of prewarmed resourceHashes in the following format: {<resourceHash>: true, ...}
     */
    async prewarmHeartbeat(heartbeatKey){
        const prewarmedResourceHashes = {}

        for(const resourceHash in requestPropertyList[heartbeatKey] || {}){

            const requestProperties = requestPropertyList[heartbeatKey][resourceHash]
            const etag = this.getETag(resourceHash)

            // use etag if and only if the corresponding resource is present
            if(etag && !!this.getResource(etag)){
                requestProperties.ifModified = true
                requestProperties.headers = requestProperties.headers || {}
                requestProperties.headers['If-None-Match'] = etag
            }

            await $.ajax(requestProperties)
                .fail(() => {
                    this.setETag(resourceHash)
                    if(etag){
                        this.setResource(etag)
                    }
                })
                .then((response, responseStatus, rawResponse) => {

                    prewarmedResourceHashes[resourceHash] = true

                    // check etag if possible
                    try {
                        const newEtag = this.returnETagIfValid(rawResponse.getResponseHeader('etag'))

                        // save new resource for later usage
                        if(responseStatus !== 'notmodified' && response && response.data){
                            // etag has changed: reset old etag to free unused memory
                            if(etag && (!newEtag || etag !== newEtag)){
                                etagResourceHandler.setResource(etag)
                            }

                            if(newEtag){
                                this.setETag(resourceHash, newEtag)
                                this.setResource(newEtag, utils.simpleCopy(response))
                            }
                        }
                    } catch (error) {}
                })
        }

        return prewarmedResourceHashes
    }
}